import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import Select from 'react-select'
import { uuidv4 } from 'uuid/v4'

/**
 * Adding Squareup Checkout Content
 */
addFilter('wp_travel_payment_gateway_fields_squareup_checkout', 'wp-travel', (content) => {
    return [...content, <SquareupCheckoutContent />]
});

const SquareupCheckoutContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const {
        squareup_access_token,
        squareup_application_id,
        squareup_location_id,
        payment_option_squareup_checkout,
        wt_test_mode
    } = allData

    const updateSquareupCheckoutData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }
    const clientIdDesc = __('Please register <a href="https://developer.squareup.com/docs/get-started" target="__blank">here</a> to get Access Token, Application ID and Location ID.', 'wp-travel-authorizenet');

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                    <strong><p className="howTo" style={{ color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen' }} >{__('Test Mode Active', 'wp-travel-pro')}</p></strong>
                    : <strong><p className="howTo" style={{ color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen' }} >{__('Live Mode Active', 'wp-travel-pro')}</p></strong>
            }
            <PanelRow>
                <label>{__('Enable Squareup Checkout', 'wp-travel-squareup-checkout')}</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={payment_option_squareup_checkout == 'yes'}
                        onChange={() => {
                            updateSettings({
                                ...allData,
                                payment_option_squareup_checkout: 'yes' == payment_option_squareup_checkout ? 'no' : 'yes'
                            })
                        }}
                    />
                    <p className="description">{__('Check to enable Squareup Checkout', 'wp-travel-squareup-checkout')}</p>
                </div>
            </PanelRow>
            {
                payment_option_squareup_checkout === 'yes' &&
                <>
                    <p><strong>Note:</strong>USD, GBP, AUD, CAD and YEN are the accepted curriencies by Squareup Checkout so please make sure to match the currency of WP Travel currency settings and the currency of your account for Squareup Checkout.

</p>
                    <PanelRow>
                        <label>{__('Access Token', 'wp-travel-squareup-checkout')}</label>
                        <div className="wp-travel-field-value">
                            <TextControl
                                value={'undefined' !== typeof squareup_access_token ? squareup_access_token : ''}
                                onChange={
                                    (value) => {
                                        updateSettings({
                                            ...allData,
                                            squareup_access_token: value
                                        })
                                    }
                                }
                            />
                            <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                        </div>
                    </PanelRow>


                    <PanelRow>
                        <label>{__('Application ID', 'wp-travel-squareup-checkout')}</label>
                        <div className="wp-travel-field-value">
                            <TextControl
                                value={'undefined' !== typeof squareup_application_id ? squareup_application_id : ''}
                                onChange={
                                    (value) => {
                                        updateSettings({
                                            ...allData,
                                            squareup_application_id: value
                                        })
                                    }
                                }
                            />
                        </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{__('Location ID', 'wp-travel-squareup-checkout')}</label>
                        <div className="wp-travel-field-value">
                            <TextControl
                                value={'undefined' !== typeof squareup_location_id ? squareup_location_id : ''}
                                onChange={
                                    (value) => {
                                        updateSettings({
                                            ...allData,
                                            squareup_location_id: value
                                        })
                                    }
                                }
                            />
                        </div>
                    </PanelRow>
                </>
            }
        </>
    )
}